import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  public get showSpinner() {
    return this.spinnerCounter > 0;
  }

  public set showSpinner(value: boolean) {
    if (value) {
      this.spinnerCounter++;
    } else {
      this.spinnerCounter--;
      if (this.spinnerCounter < 0) {
        this.spinnerCounter = 0;
      }
    }
  }

  private spinnerCounter = 0;

  // detour counter
  public reset() {
    this.spinnerCounter = 0;
  }

}
